export const LOCAL_STORAGE_KARDIA_OPS = 'external_operations'
export const LOCAL_STORAGE_AUTH_TOKEN = `${LOCAL_STORAGE_KARDIA_OPS}_token`
export const PASSWORD = 'password'
export const INTERVAL_AUTH_CHECKER = 30000; // 30 seconds
export const CONVERT_TO_SECONDS = 1000 // milli second to second conversion

export const APP_ROUTS = {
  ROOT: '/',
  LOGIN: '/login',
  ADD_PATIENT: '/add-patient',
}
export const DATE_FORMAT = {
  ISO_8601_FORMATS : {
    DATE: 'YYYY-MM-DD',
    TIME: 'HH:mm',
  },
  US_FORMATS : {
    DATE: 'MM-DD-YYYY',
    TIME: 'hh:mm A',
  },
  DATEPICKER_FORMAT : {
    DATE: 'dd/MM/yyyy',
  }
}

export const URLS = {
  LOGIN: '/v1/apikey',
  CREATE_PATIENT: '/v1/patients',
  CREATE_USER: '/v1/users'
};

export const GENDER = [
  {
    value: 1,
    label: 'Male',                   
  },
  {
    value: 2,
    label: 'Female',                   
  }
]
